// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dots{border-top:1px dotted #cacaca;flex:1}@media(min-width:1280px){.card-float{float:right}}.video-sizer{width:calc(100% - 420px - 16vw);padding-bottom:26%;position:relative}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
